import React from "react";
import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { axiosInstance } from "../../utility/apiInstance";
import { Plane, ClipboardList, Building, Package, Weight } from "lucide-react";

import {
  TextField,
  Box,
  useMediaQuery,
} from "@mui/material";
import toast from "react-hot-toast";
import { useSearchParams, useNavigate } from "react-router-dom";
import HistoryIcon from "@mui/icons-material/History";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import TabularViewTraclist from "../../components/TabularViewTraclist";

const defaultTheme = createTheme();

interface Milestone {
  etd: string;
  eta: string;
  status: number;
  milestone: string;
  origin?: string;
  station?: string;
  date: string;
}

const HistoryTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const DetailsTrackingOfAWB = ({
  trackingId,
  ourJson
}: {
  trackingId: string | null;
  ourJson: any | null
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [searchparams] = useSearchParams();
  const navigate = useNavigate();
  const params = trackingId || searchparams.get("trackingId");
  const [milestones, setMilestones] = useState<Milestone[]>([]);
  // const [isVertical, setIsVertical] = useState(false);
  const [trackList, setTrackList] = useState(null) as any;



  const [dialogIndex, setdialogIndex] = useState<null | number>(null);
  const [tabularViewData, settabularViewData] = useState(null);

  const handleRedirect = () => {
    navigate("/tracking-management");
  };

  useEffect(() => {
    if (ourJson) {

      setTrackList(ourJson);
      setMilestones(ourJson.events);
    } else {
      awsTrackedList();
    }
    async function awsTrackedList() {
      try {
        const response = await axiosInstance.get(
          `/api/v1/awb-tracked-list/${params}`
        );
        if (response.data.success) {
          setTrackList(response.data.data);
          setMilestones(response.data.data.events);

        }
      } catch (error: any) {
        const apiError =
          error?.response?.data?.error || "Something went wrong.";
        setTimeout(() => {
          toast.dismiss();
          toast.error(apiError);
        }, 500);
        handleRedirect();
      }
    }
    getTablurViewTrackDetail();
  }, [params]);





  function calculateSum(elements: any) {
    let sum = 0;
    elements.forEach((element: any) => {
      sum += element?.pieces || 0;
    });
    return sum;
  }
  function checkIsYellow(events: any) {
    let isYelloy = false;


    let countStatusOne = 0;

    for (let milestone of events) {
      if (milestone.status == 1) {
        countStatusOne++;
      }
    }
    for (let milestone of events) {
      if (milestone.status == 0 && milestone.isDetailAwaitedForPartShipment && events.length != countStatusOne) {
        isYelloy = true
        return true;
      }
    }
    for (let milestone of events) {
      if (milestone.isDetailAwaitedForPartShipment && events.length == countStatusOne) {
        return true
      }
    }
    for (let milestone of events) {
      if (events.length != countStatusOne) {
        isYelloy = true

        return true;
      }
    }


    return isYelloy
  }

  const handleHistoryOpen = async (
    index: any,
    milestone: string,
    flightNumber: string
  ) => {
    setdialogIndex(index);
  };

  const handleHistoryClose = () => {
    setdialogIndex(null);
  };

  const getTablurViewTrackDetail = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/awb-tracked-list/tabular-view/${params}`
      );
      let { status, flightsEtdEta, events } = response?.data?.data;
      status = status?.map((item: any) => ({ ...item, status: "status" }));
      flightsEtdEta = flightsEtdEta?.map((item: any) => ({
        ...item,
        status: "flight",
      }));
      events = events?.map((item: any) => ({ ...item, status: "event" }));
      const mergerdRes = [...status, ...flightsEtdEta, ...events] as any;
      settabularViewData(mergerdRes);
    } catch (err) { }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="scrollwhiteBox overflow-x-auto">
        <Box component="form" noValidate autoComplete="off">
          <div className="flex flex-wrap gap-4">
            {/* Each block - Set fixed min width for responsiveness */}
            <div className="min-w-[200px] flex-1 lg:max-w-[18%]">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center items-center">
                  <ClipboardList className="text-yellow-400" />
                </figure>
                <aside className="ml-4 w-full">
                  <TextField
                    id="awb-number"
                    label="AWB Number"
                    defaultValue={trackList?.awbNumber}
                    value={trackList?.awbNumber}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    fullWidth
                    style={{
                      padding:"3px"
                    }}
                  />
                </aside>
              </div>
            </div>

            {/* Destination */}
            <div className="min-w-[200px] flex-1 lg:max-w-[18%]">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center items-center">
                  <Building className="text-yellow-400" />
                </figure>
                <aside className="ml-4 w-full">
                  <TextField
                    id="destination"
                    label="Destination"
                    defaultValue={trackList?.destination}
                    value={trackList?.destination}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    fullWidth
                  />
                </aside>
              </div>
            </div>

            {/* Origin */}
            <div className="min-w-[200px] flex-1 lg:max-w-[18%]">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center items-center">
                  <Plane className="text-yellow-400" />
                </figure>
                <aside className="ml-4 w-full">
                  <TextField
                    id="origin"
                    label="Origin"
                    defaultValue={trackList?.origin}
                    value={trackList?.origin}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    fullWidth
                  />
                </aside>
              </div>
            </div>

            {/* Pkts */}
            <div className="min-w-[200px] flex-1 lg:max-w-[18%]">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center items-center">
                  <Package className="text-yellow-400" />
                </figure>
                <aside className="ml-4 w-full">
                  <TextField
                    id="pieces"
                    label="Pkts"
                    defaultValue={trackList?.pieces}
                    value={trackList?.pieces}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    fullWidth
                  />
                </aside>
              </div>
            </div>

            {/* Weight */}
            <div className="min-w-[200px] flex-1 lg:max-w-[18%]">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center items-center">
                  <Weight className="text-yellow-400" />
                </figure>
                <aside className="ml-4 w-full">
                  <TextField
                    id="weight"
                    label="Weight"
                    defaultValue={trackList?.weight}
                    value={trackList?.weight}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    fullWidth
                  />
                </aside>
              </div>
            </div>
          </div>
        </Box>
      </div>


      <div className="whiteBox  mt-5 mb-5">
        <>
          <div className="relative w-full overflow-x-auto">
            <div className="oldRoadMap  ">
              <div className="relative mx-auto max-w-screen-lg px-0  lg:px-3 ms:px-3 sm:px-0">
                <div className="relative   flex-none lg:flex md:flex  sm:flex-none  justify-between mt-[90px] mb-[70px] text-xs">
                  {milestones.map((element: any, index: number) => (
                    <div
                      key={index}
                      className="relative oldroadinn flex flex-col items-center w-[325px] mb-5"
                    >
                      <div
                        className={`w-[20px] h-[20px] roadCircle rounded-full ${element[0]?.milestone === "Delivered"
                          ? calculateSum(element) === trackList.pieces
                            ? "bg-green-500"
                            : element[0].status === 0
                              ? "bg-gray-500"
                              : checkIsYellow(element) ? "bg-yellow-500" : "bg-green-500"
                          : element[0].status === 0 ? "bg-gray-500" : checkIsYellow(element) ? "bg-yellow-500" : "bg-green-500"
                          } absolute top-1/2 transform -translate-y-1/2`}
                      ></div>
                      <div
                        className={` oldroadLine ${index === 0
                          ? "absolute left-[51%]"
                          : "absolute left-[-51%]"
                          } ${milestones.length - 1 === index
                            ? "right-[50%]"
                            : milestones.length === 3
                              ? "right-[-55%]"
                              : milestones.length === 4
                                ? "right-[-50%]"
                                : "right-[-50%]"
                          } top-1/2 h-[4px] ${element[0].milestone === "Delivered"
                            ? calculateSum(element) === trackList.pieces
                              ? "bg-green-500"
                              : element[0].status === 0
                                ? "bg-gray-500"
                                : checkIsYellow(element) ? "bg-yellow-500" : "bg-green-500"
                            : element[0].status === 0 ? "bg-gray-500" : checkIsYellow(element) ? "bg-yellow-500" : "bg-green-500"
                          } z-[-1] transform translate-y-[-50%]`}
                      ></div>
                      <div
                        className={` oldRoadBox ${element.length >= 2 ? 'w-[220px]' : 'w-[205px]'} ${index % 2 === 0 ? "mt-[245px]" : ""
                          } dark:border-white p-[5px]`}
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                        }}
                      >
                        {
                          <>
                            <div className="flex flex-col items-center">
                              <div className="boxx">
                                <div className="flex items-center justify-start relative">
                                  <p className="text-center">
                                    {element.length >= 2 || element[0].isDetailAwaitedForPartShipment ? element[0].milestone + " (Part) " : element[0].milestone}
                                  </p>
                                  {element[0]?.milestone !== "Gate In" &&
                                    element[0]?.milestone !== "Active" &&
                                    element[0]?.milestone !== "Delivered" && (
                                      <>
                                        <ClickAwayListener
                                          onClickAway={() => {
                                            return;
                                          }}
                                        >
                                          <div className="absolute right-0 ml-[7px]">
                                            <HistoryTooltip
                                              title={
                                                <React.Fragment>
                                                  <p
                                                    style={{
                                                      fontSize: "12px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {element[0]?.milestone +
                                                      " " +
                                                      (element[0]?.milestone.includes(
                                                        "Departure"
                                                      )
                                                        ? element[0]?.origin
                                                        : element[0]?.station)}
                                                  </p>
                                                  <h3 className="roadPlan">
                                                    Planned
                                                  </h3>
                                                  {element[0]
                                                    ?.flightSummary && (
                                                      <p
                                                        style={{
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        {(() => {
                                                          const flightSummary =
                                                            element[0]
                                                              ?.flightSummary[0]
                                                              ?.flightId;
                                                          if (!flightSummary)
                                                            return "";

                                                          const etdValid =
                                                            flightSummary.etd &&
                                                            !isNaN(
                                                              new Date(
                                                                flightSummary.etd
                                                              ).getTime()
                                                            );
                                                          const etaValid =
                                                            flightSummary.eta &&
                                                            !isNaN(
                                                              new Date(
                                                                flightSummary.eta
                                                              ).getTime()
                                                            );

                                                          if (
                                                            etdValid &&
                                                            element[0]?.milestone.includes(
                                                              "Departure"
                                                            )
                                                          ) {
                                                            return `${flightSummary.flightNumber
                                                              } ${new Intl.DateTimeFormat(
                                                                "en-GB",
                                                                {
                                                                  dateStyle:
                                                                    "short",
                                                                  timeStyle:
                                                                    "short",
                                                                }
                                                              ).format(
                                                                new Date(
                                                                  flightSummary.etd
                                                                )
                                                              )}`;
                                                          } else if (etaValid) {
                                                            return `${flightSummary.flightNumber
                                                              } ${new Intl.DateTimeFormat(
                                                                "en-GB",
                                                                {
                                                                  dateStyle:
                                                                    "short",
                                                                  timeStyle:
                                                                    "short",
                                                                }
                                                              ).format(
                                                                new Date(
                                                                  flightSummary.eta
                                                                )
                                                              )}`;
                                                          }
                                                          return "";
                                                        })()}
                                                      </p>
                                                    )}

                                                  {element[0]
                                                    ?.flightSummary && (
                                                      <div
                                                        style={{
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        {element[0]?.flightSummary.map(
                                                          (
                                                            flight: any,
                                                            index: any
                                                          ) => (
                                                            <p key={index}>
                                                              <del>
                                                                {(() => {
                                                                  const oldEtdValid =
                                                                    flight.oldEtd &&
                                                                    !isNaN(
                                                                      new Date(
                                                                        flight.oldEtd
                                                                      ).getTime()
                                                                    );
                                                                  const oldEtaValid =
                                                                    flight.oldEta &&
                                                                    !isNaN(
                                                                      new Date(
                                                                        flight.oldEta
                                                                      ).getTime()
                                                                    );

                                                                  if (
                                                                    oldEtdValid &&
                                                                    element[0]?.milestone.includes(
                                                                      "Departure"
                                                                    )
                                                                  ) {
                                                                    return `${flight
                                                                      .flightId
                                                                      .flightNumber
                                                                      } ${new Intl.DateTimeFormat(
                                                                        "en-GB",
                                                                        {
                                                                          dateStyle:
                                                                            "short",
                                                                          timeStyle:
                                                                            "short",
                                                                        }
                                                                      ).format(
                                                                        new Date(
                                                                          flight.oldEtd
                                                                        )
                                                                      )}`;
                                                                  } else if (
                                                                    oldEtaValid
                                                                  ) {
                                                                    return `${flight
                                                                      .flightId
                                                                      .flightNumber
                                                                      } ${new Intl.DateTimeFormat(
                                                                        "en-GB",
                                                                        {
                                                                          dateStyle:
                                                                            "short",
                                                                          timeStyle:
                                                                            "short",
                                                                        }
                                                                      ).format(
                                                                        new Date(
                                                                          flight.oldEta
                                                                        )
                                                                      )}`;
                                                                  }
                                                                  return "";
                                                                })()}
                                                              </del>
                                                            </p>
                                                          )
                                                        )}
                                                      </div>
                                                    )}

                                                  <p
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Actual
                                                  </p>
                                                  <p
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    {element[0]?.status === 1
                                                      ? `${element[0]
                                                        ?.flightNumber
                                                      } ${element[0]?.date &&
                                                        !isNaN(
                                                          new Date(
                                                            element[0]?.date
                                                          ).getTime()
                                                        )
                                                        ? new Date(
                                                          element[0]?.date
                                                        ).toLocaleDateString(
                                                          "en-GB"
                                                        )
                                                        : "Invalid Date"
                                                      }`
                                                      : "Pending"}
                                                  </p>
                                                  <div className="mt-2 text-right">
                                                    <button
                                                      className="px-2 py-1 text-sm text-blue-500"
                                                      onClick={
                                                        handleHistoryClose
                                                      }
                                                    >
                                                      Close
                                                    </button>
                                                  </div>
                                                </React.Fragment>
                                              }
                                              open={index === dialogIndex}
                                              disableFocusListener
                                              disableHoverListener
                                              disableTouchListener
                                              placement="right"
                                            >
                                              <HistoryIcon
                                                style={{
                                                  fontSize: "18px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  handleHistoryOpen(
                                                    index,
                                                    element[0].milestone,
                                                    element[0].flightNumber
                                                  )
                                                }
                                              />
                                            </HistoryTooltip>
                                          </div>
                                        </ClickAwayListener>
                                      </>
                                    )}
                                </div>
                              </div>
                              {(() => {
                                const mileStoneArray =
                                  element[0]?.milestone.split(" ");
                                return mileStoneArray[
                                  mileStoneArray.length - 1
                                ] === "Departure" ? (
                                  <h4 className="roadPlann">
                                    {element[0].origin}
                                  </h4>
                                ) : (
                                  <h4 className="roadPlann">
                                    {element[0].station}
                                  </h4>
                                );
                              })()}
                              <div className="raodDataMain">
                                {element.map((milestone: any, ind: number) => (
                                  <>
                                    <div className="raodData">
                                      <figure className="flex justify-start">
                                        {milestone?.milestone ===
                                          "Origin Departure" ||
                                          milestone?.milestone ===
                                          "Trans Shipment Departure" ? (
                                          <Plane
                                            className={`${milestone?.status === 1
                                              ? "text-green-500"
                                              : "text-gray-500"
                                              }`}
                                          />
                                        ) : milestone?.milestone ===
                                          "Trans Shipment Arrival" ||
                                          milestone?.milestone === "Arrived" ||
                                          milestone?.milestone === "Arrival" ? (
                                          <Plane
                                            className={`${milestone?.status === 1
                                              ? "text-green-500"
                                              : "text-gray-500"
                                              }`}
                                          />
                                        ) : null}
                                      </figure>
                                      <small>
                                        {element[ind]?.milestone ===
                                          "Gate In" &&
                                          element[ind]?.status === 0 ? (
                                          "Details Awaited"
                                        ) : element[ind]?.status === 1 ? (
                                          <div>
                                            {milestone.date && `Date : ${new Date(
                                              milestone.date
                                            ).toLocaleString("en-IN", {
                                              timeZone: "Asia/Kolkata",
                                              year: "numeric",
                                              month: "2-digit",
                                              day: "2-digit",
                                            })}`}
                                            <br />
                                            {element[ind]?.milestone ===
                                              "Active" ? null : element[ind]
                                                ?.milestone === "Gate In" ||
                                                element[ind]?.milestone ===
                                                "Delivered" ? (
                                              <span>{element[ind].pieces && `${element[ind].pieces}Pkts`}</span>
                                            ) : (
                                              <span>
                                                {element[ind]?.pieces && `${element[ind].pieces}Pkts / ${element[ind]
                                                  ?.flightNumber
                                                  } `}
                                              </span>
                                            )}
                                          </div>
                                        ) : element[ind]?.old_etd ||
                                          element[ind]?.old_eta ? (
                                          <>
                                            {element[ind]?.old_etd && (
                                              <div>
                                                <del>
                                                  ETD:{" "}
                                                  {new Date(
                                                    element[ind]?.old_etd
                                                  ).toLocaleString("en-IN", {
                                                    timeZone: "Asia/Kolkata",
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                  })}
                                                  <br />
                                                  <span>
                                                    {new Date(
                                                      element[ind]?.old_etd
                                                    ).toLocaleTimeString(
                                                      "en-IN",
                                                      {
                                                        timeZone:
                                                          "Asia/Kolkata",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hourCycle: "h23",
                                                      }
                                                    )}
                                                    {" / "}
                                                    {element[ind]?.flightNumber}
                                                  </span>
                                                </del>
                                              </div>
                                            )}
                                            {element[ind]?.old_eta && (
                                              <div>
                                                <del>
                                                  ETA:{" "}
                                                  {new Date(
                                                    element[ind]?.old_eta
                                                  ).toLocaleString("en-IN", {
                                                    timeZone: "Asia/Kolkata",
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                  })}
                                                  <br />
                                                  <span>
                                                    {new Date(
                                                      element[ind]?.old_eta
                                                    ).toLocaleTimeString(
                                                      "en-IN",
                                                      {
                                                        timeZone:
                                                          "Asia/Kolkata",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hourCycle: "h23",
                                                      }
                                                    )}
                                                    {" / "}
                                                    {element[ind]?.flightNumber}
                                                  </span>
                                                </del>
                                              </div>
                                            )}
                                            {element[ind]?.etd ||
                                              element[ind]?.eta ? (
                                              <>
                                                {element[ind]?.etd && (
                                                  <div>
                                                    NEW ETD:{" "}
                                                    {new Date(
                                                      element[ind]?.etd
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.etd
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                                {element[ind]?.eta && (
                                                  <div>
                                                    NEW ETA:{" "}
                                                    {new Date(
                                                      element[ind]?.eta
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.eta
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                              </>
                                            ) : null}
                                          </>
                                        ) : (
                                          <>
                                            {element[ind]?.etd ||
                                              element[ind]?.eta ? (
                                              <>
                                                {element[ind]?.etd && (
                                                  <div>
                                                    ETD:{" "}
                                                    {new Date(
                                                      element[ind]?.etd
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.etd
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                                {element[ind]?.eta && (
                                                  <div>
                                                    ETA:{" "}
                                                    {new Date(
                                                      element[ind]?.eta
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.eta
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              "Details Awaited"
                                            )}
                                          </>
                                        )}
                                      </small>
                                    </div>
                                  </>
                                ))}
                                <div className="roadData">
                                  {element[0].isDetailAwaitedForPartShipment && (
                                    <div className="grid place-content-center font-semibold text-sm bg-amber-50 px-3 py-1 rounded">
                                      {trackList.pieces - calculateSum(element) + "pkts" + ", Details Awaited"}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      </div>


      {tabularViewData != null && (
        <TabularViewTraclist tabularViewData={tabularViewData} />
      )}
    </ThemeProvider>
  );
};

export default DetailsTrackingOfAWB;
